import { render, staticRenderFns } from "./EmailAliases.vue?vue&type=template&id=0ab2b392&scoped=true"
import script from "./EmailAliases.vue?vue&type=script&lang=js"
export * from "./EmailAliases.vue?vue&type=script&lang=js"
import style0 from "./EmailAliases.vue?vue&type=style&index=0&id=0ab2b392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2b392",
  null
  
)

export default component.exports